import { combineReducers } from 'redux';

import fetch, * as fromFetch from './fetch';
import update, * as fromUpdate from './update';

export default combineReducers({
  fetch,
  update,
});

export const isFetching = (state) => fromFetch.isFetching(state.fetch);

export const getCode = (state) => fromFetch.getCode(state.fetch);

export const getMappings = (state) => fromFetch.getMappings(state.fetch);

export const isUpdating = (state) => fromUpdate.isUpdating(state.update);

export const getUpdatingCode = (state) => fromUpdate.getCode(state.update);
